:host {
    display: block;
    position: relative;
}

dialog {
    .grid {
        @include grid;
    }

    background-color: rgba($color-black, 80%);
    margin: 0;
    padding: 0;
    border: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: calc(100% - var(--header-height));

    ::slotted(sew-picture[slot='zoom']) {
        grid-column: 2 / -2;
        display: block;
        height: calc(100vh - var(--header-height) - 200px);
    }
}

.close-btn {
    all: unset;
    grid-column: -3 / span 2;
    grid-row: 1;
    justify-self: end;
    margin: 34px 34px 34px 0;
    cursor: pointer;

    .svg {
        width: 32px;
        color: $color-white;
    }
}

.zoom-btn {
    all: unset;
    position: absolute;
    right: 0;
    top: 0;
    background-color: $color-grey-04-middle;
    pointer-events: none;

    .svg {
        width: 48px;
        color: $color-grey-02-steel;
    }
}

@include mq-3-min {
    .zoom-btn {
        display: none;
    }
}

:host(:hover) {
    .zoom-btn {
        display: block;
    }
}

:host(.scrolled) {
    dialog {
        height: calc(100% - var(--header-height-scrolled));
    }
}

@include mq-1 {
    .zoom-btn {
        display: none !important;
    }
}

@include mq-2 {
    .close-btn {
        margin-right: calc(var(--grid-margin) - 6px);
    }
}

@include mq-4-min {
    .close-btn {
        grid-column: -3;
        margin-right: 0;
    }
}
